export default "__VITE_ASSET__56429e84__"